module.exports = __webpack_public_path__ + "static/media/IconFacebook.69a104c5.svg";